import React from 'react';
import facebook from '../../assets/social_facebook.svg';
import linkedin from '../../assets/social_linkedin.svg';
import footerIcon from '../../assets/qfc_symbol_dark.svg';
import appstore from '../../assets/appstore_sv.svg';
import playstore from '../../assets/playstore_sv.svg';
import './footer.css';
import FadeInSection from '../../animation/fadein_onscroll';
import { useTranslation } from 'react-i18next';


function Footer() {
    const { t } = useTranslation();

return (
<FadeInSection>
    <footer className="footer row center main-padding">
        <div className="footer-items column" id="contact">
            <div className="column">
                <h2>{t('footer.title')}</h2>
                <div className="footer-cta-buttons">
                    <a className="button-primary large" href="/plans">{t('common.getAccess')}</a>
                    <a className="button-secondary large" href="/contact">{t('common.contactUs')}</a>
                </div>
            </div>
            <br />
            <br />
            <div className="column">
            <div className="column">
                <a tabIndex="5" className="arrow" href='/terms' aria-label={t('footer.ariaTerms')}>{t('footer.terms')}</a>
                <a tabIndex="5" className="arrow" href='/privacy' aria-label={t('footer.ariaPrivacy')}>{t('footer.privacy')}</a>
                <a tabIndex="5" className="arrow" href='/support' aria-label={t('footer.ariaSupport')}>{t('footer.support')}</a>
            </div>
            <div className="row store">
                <a tabIndex="5" className="store-icon" href='https://apps.apple.com/se/app/quality-food-control/id6469708374?l=en-GB' target="blank" aria-label={t('footer.ariaAppStore')}>
                    <img src={appstore} className="" alt={t('footer.ariaAppStore')} />
                </a>
                <a tabIndex="5" className="store-icon" href='https://play.google.com/store/apps/details?id=com.qualityfoodcontrol.app&hl=sv' target="blank" aria-label={t('footer.ariaPlayStore')}>
                    <img src={playstore} className="" alt={t('footer.ariaPlayStore')} />
                </a>
            </div>
            <div className="row">
                <a tabIndex="5" className="social-icon" href='https://www.facebook.com/qualityfoodcontrol' target="blank" aria-label={t('footer.ariaFacebook')}>
                    <img src={facebook} className="" alt={t('footer.ariaFacebook')} />
                    <span className="tooltip">{t('footer.facebook')}</span>
                </a>
                <a tabIndex="5" className="social-icon" href='https://www.linkedin.com/company/quality-food-control/' target="blank" aria-label={t('footer.ariaLinkedIn')}>
                    <img src={linkedin} className="" alt={t('footer.ariaLinkedIn')} />
                    <span className="tooltip">{t('footer.linkedIn')}</span>
                </a>
            </div>
            <span className="slogan desktop">
                {t('footer.copyright')}
            </span>
            </div>
        </div>
        <img src={footerIcon} className="symbol" alt={t('footer.altSymbol')} />
        <br />
        <span className="slogan mobile">
            {t('footer.copyright')}
        </span>
    </footer>
</FadeInSection>
);
}

export default Footer;